/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, April 17th 2022, 5:52:21 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { FormControl, Stack, Typography } from "@mui/material";
import { WYSIWYG, WYSIWYGProps } from "ui-widgets/editors/WYSIWYG";
import { OSFormInputProps, useControlledInput } from "ui-widgets/forms";
import {
  APIFormInputErrorWrapper,
  CustomInputValidationErrorWrapper,
  HelperTextInputWrapper,
} from "ui-widgets/forms/FormInputWrappers";

export type WYSIWYGInputProps<T> = OSFormInputProps<T> & WYSIWYGProps;

export const WYSIWYGInput = <T,>(props: WYSIWYGInputProps<T>) => {
  const {
    field: { onChange, value },
  } = useControlledInput<T>(props);

  return (
    <APIFormInputErrorWrapper schema_field_key={props.schema_field_key} label={props.label}>
      <CustomInputValidationErrorWrapper schema_field_key={props.schema_field_key} label={props.label}>
        <HelperTextInputWrapper helperText={props.helperText}>
          <FormControl>
            <Stack spacing={2}>
              {props.label ? (
                <Typography variant="h4" sx={{ fontWeight: 800, fontSize: "0.8rem" }}>
                  {props.label}
                </Typography>
              ) : null}
              <WYSIWYG onChange={onChange} defaultValue={value as string} minHeight={props.minHeight} {...props} />
            </Stack>
          </FormControl>
        </HelperTextInputWrapper>
      </CustomInputValidationErrorWrapper>
    </APIFormInputErrorWrapper>
  );
};
